import React from 'react';
import { Link } from 'react-router-dom';
import { HomeIcon, TrophyIcon, BellIcon, QuestionMarkCircleIcon, ShieldCheckIcon } from '@heroicons/react/24/outline';

function Footer() {
  return (
    <footer className="fixed bottom-0 left-0 right-0 bg-[#b34e42]/80 backdrop-blur-sm border-t border-[#402e2c]/20">
      <div className="container mx-auto px-4">
        <nav className="flex items-center justify-between py-3">
          <Link to="/home" className="flex flex-col items-center text-[#402e2c] hover:text-white transition-colors duration-300">
            <HomeIcon className="h-6 w-6" />
            <span className="text-xs mt-1">Home</span>
          </Link>
          
          <Link to="/leaderboard" className="flex flex-col items-center text-gray-400 hover:text-[#402e2c] transition-colors duration-300">
            <TrophyIcon className="h-6 w-6" />
            <span className="text-xs mt-1">Leaderboard</span>
          </Link>
          
          <Link to="/notifications" className="flex flex-col items-center text-gray-400 hover:text-[#402e2c] transition-colors duration-300">
            <BellIcon className="h-6 w-6" />
            <span className="text-xs mt-1">Notifications</span>
          </Link>
          
          <Link to="/help" className="flex flex-col items-center text-gray-400 hover:text-[#402e2c] transition-colors duration-300">
            <QuestionMarkCircleIcon className="h-6 w-6" />
            <span className="text-xs mt-1">Help</span>
          </Link>
          
          <Link to="/privacy" className="flex flex-col items-center text-gray-400 hover:text-[#402e2c] transition-colors duration-300">
            <ShieldCheckIcon className="h-6 w-6" />
            <span className="text-xs mt-1">Privacy</span>
          </Link>
        </nav>
      </div>
    </footer>
  );
}

export default Footer; 